import { endOfDay, startOfDay } from 'date-fns'
import { useAPI } from 'api/client'

export const COMMENTS_BLOCK_TYPE = 'COMMENTS'
export const COMMENTS_BLOCK_TITLE = 'Comments'

/** @param {import('./ReportCommentsForm.types').CriteriaConfig} criteria */
export const defaultCriteriaTitleFormatter = (criteria) => (criteria.description ? `${criteria.name} | ${criteria.description}` : criteria.name)

/**
 * @param {import('./config.types').CriteriaConfig} firstCriteria
 * @returns {import('./config.types').CommentsBlockConfig}
 */
export const defaultCustomCommentsBlockConfig = (firstCriteria) => ({
  section: {
    id: firstCriteria.id,
    name: firstCriteria.name,
    description: firstCriteria.description
  },
  showThemeComments: true,
  showQuestionComments: false,
  title: defaultCriteriaTitleFormatter(firstCriteria)
})

export const useCommentsDefault = () => {
  const { data } = useAPI('reports/form/comments/')

  return {
    from: startOfDay(data?.defaultFrom || Date.now()).getTime(),
    to: endOfDay(Date.now()).getTime()
  }
}
